import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";

// Okno modalne (error dialog) informujące o przekroczeniu limitu miejsca na
// dysku. Wygląd wg projektu Figma (Basic dialog / error). Pokazywane z paska
// bocznego gdy zajętość >= 100%.
const DiskQuotaExceededModal = ({
  onCancel,
  onIncreaseSpace,
}: {
  onCancel: () => void;
  onIncreaseSpace: () => void;
}) => {
  const { t } = useTranslation();

  return ReactDOM.createPortal(
    <div className={styles.modal} onClick={onCancel}>
      <div className={styles.wrapper} onClick={(e) => e.stopPropagation()}>
        <div className={styles.content}>
          <div className={styles.title}>
            {t("diskSpaceModal.exceededTitle")}
          </div>
          <div className={styles.body}>{t("diskSpaceModal.exceededBody")}</div>
        </div>

        <div className={styles.actions}>
          <button className={styles.secondaryBtn} onClick={onCancel}>
            {t("diskSpaceModal.cancel")}
          </button>
          <button className={styles.primaryBtn} onClick={onIncreaseSpace}>
            {t("diskSpaceModal.increaseSpace")}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default DiskQuotaExceededModal;
